<template>
  <a class="text-decoration-none" role="button" :aria-label="'Link to ' + publication.Title" :href="publication.DetailsUrl">
    <article class="d-flex flex-column publication-card">
      <h3 class="m-0 text-primary large"><strong>{{publication.Title}}</strong></h3>
      <div class="d-none d-md-flex align-items-baseline">
        <span class="mt-1">{{getDate}}</span>
        <span v-if="publication.Author">
          <span class="mx-2">|</span>
          <span class="link">{{publication.Author}}</span>
        </span>
      </div>
      <div class="d-flex d-md-none align-items-baseline flex-wrap">
        <span class="mt-1 w-100">{{getDate}}</span>
        <span class="link w-100" v-if="publication.Author">{{publication.Author}}</span>
      </div>
      <div class="publication-card_description mt-3" v-html="publication.Description"></div>
      <div class="d-flex pt-4 publication-card_icons">
        <template v-for="document in publication.RelatedDocuments">
          <a v-if="document.Type" target="_blank" :href="document.Url">
            <i :class="iconClasses[document.Type]">
              <span class="text-primary fw-normal ms-2">{{ document.Type }}</span>
            </i>
          </a>
        </template>
        <a v-if="publication.Podcasts" :href="publication.Podcasts">
          <i :class="iconClasses.Podcast">
            <span class="text-primary fw-normal ms-2">Podcast</span>
          </i>
        </a>
      </div>
    </article>
  </a>
</template>
<script>
  import { computed, ref } from 'vue';
  import moment from 'moment';

  export default {
    name: 'PublicationCard',
    props: {
      publication: {
        type: Object,
        required: true
      }
    },
    setup(props) {
      const iconClasses = ref({
        Brief: 'fa-solid fa-sheet-plastic',
        Guide: 'fa-solid fa-file-waveform',
        Infographic: 'fa-sharp fa-solid fa-chart-pie',
        Multimedia: 'fa-solid fa-photo-film-music',
        Report: 'fa-solid fa-book-open',
        'Press Release': 'fa-solid fa-newspaper',
        'Byline Article': 'fa-solid fa-file-pen',
        Podcast: 'fa-solid fa-microphone',
        Video: 'fa-solid fa-video',
        Cookbook: 'fa-solid fa-utensils',
      });

      const getDate = computed(() => {
        var date = "";
        if (props.publication.OriginalPublicationDate) {
          date = moment(String(props.publication.OriginalPublicationDate), 'MM-DD-YYYY').format('MMMM YYYY');
        }

        return date;
      });

      return {
        iconClasses,
        getDate
      };
    }
  };
</script>
